<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {"num_cand":"U2FsdGVkX18JuavTrqRh60PxjZ7xxdLZNXcXLkHAZYs=","cpf":"U2FsdGVkX1+iYBUN3XDI8jqMUNFp82lQTCltIxpSmRs="},{"num_cand":"U2FsdGVkX1/K/vd/27IJtLlNf3PF+duSk1jkeKKlTcg=","cpf":"U2FsdGVkX1+pkBs6nNUDdUsh49nKpTl5nQ2tdpH82g4="},{"num_cand":"U2FsdGVkX19YGFLADG8ZZc8ilqniIGTGJtyNNTQMyso=","cpf":"U2FsdGVkX1/J6Mh1z+xHlGo0oQ4muvLFDNkQL56F75o="},{"num_cand":"U2FsdGVkX1+v9VwELVCSieB+b+ChHsv6Xkl8xzvO9tk=","cpf":"U2FsdGVkX184/XgzbisthGkN3Z1zbqAcHzMbQOhn9co="},{"num_cand":"U2FsdGVkX1+Chmfakzl+Or2IFtmV7cCdqPrY8NEb2bk=","cpf":"U2FsdGVkX1+R6Pdhcof8f4XxoIxfNnW03nqbPipHvdw="},{"num_cand":"U2FsdGVkX18rKHrtJ2UQpInP2fiJt8kliWRrXhyNjWI=","cpf":"U2FsdGVkX1/uWGQsSc2SlKsbwLunLzKpRVlSGHLkTOA="},{"num_cand":"U2FsdGVkX186ZGMHZprj9x8Ve0Xn0E8HBB3d+1F0KRE=","cpf":"U2FsdGVkX1/HvpQW/eR0jf7LeY95JrsJVa39tk1yVB4="},{"num_cand":"U2FsdGVkX19lVaX7xkv32nwFu82CVZoDk1Z46F8mHs0=","cpf":"U2FsdGVkX1/GlwGVIkc8y+pLuRzSuajv+trXrOSCR8M="},{"num_cand":"U2FsdGVkX1/X3QvByENI4NemYjT+AIuiGSMvoJ+46G0=","cpf":"U2FsdGVkX19zD1r3gmYte8abxenmakiwGxp8bOeOROI="},{"num_cand":"U2FsdGVkX1/f6XMKTJX9y+NAOEIzjsJupxvmRP/7MJU=","cpf":"U2FsdGVkX18V3PlD5Skfp617HlPLUVnCzeeFxK7IKYo="},{"num_cand":"U2FsdGVkX1/vhSH031Zf/zvgbOeH5j+QVPg2iqTothw=","cpf":"U2FsdGVkX1+hLE1r0TmJCk01+PJYTHEbwZm5xBXGHeM="},{"num_cand":"U2FsdGVkX19UpA6tK9WvTm6taZyxj1eMxxN+o9szLWs=","cpf":"U2FsdGVkX19SWCOMsnSylEyGBDMMTG3xyHVvRbDxeYg="},{"num_cand":"U2FsdGVkX19H52Io+UlrxCe65kFKfWDvXWRuwFCX5Mw=","cpf":"U2FsdGVkX1/si1d3oo5nh9sZV1lDiKiF+HXvAbYj0qM="},{"num_cand":"U2FsdGVkX1+2pdC4A9r2PjMMiLNcvXv+rTFuFp9WHZw=","cpf":"U2FsdGVkX196jhENxt1o8zamtyirhKLjfjehjBVNXoE="},{"num_cand":"U2FsdGVkX19GXBehMwNG4eSVQo/AVlGW3x92IiMbyAw=","cpf":"U2FsdGVkX1/bgkT6weatHe/Y8V7FICfC73s42MKGajo="},{"num_cand":"U2FsdGVkX190gM7unG5X+ItULWyIWp+1BCm/l2Yy0uM=","cpf":"U2FsdGVkX18QQUI3udXDMkkiRI4gNWxcIt2Uu1MXQ/Y="},{"num_cand":"U2FsdGVkX1+IyZIE1i9yqRsD9x4CuyK5GQNx7rkMfho=","cpf":"U2FsdGVkX19mpqR5fZ0WlWI/jw8IVFMuoPHzrIVahOw="},{"num_cand":"U2FsdGVkX18490vglo5S0S9feZ+42zaLdxfviONoN3c=","cpf":"U2FsdGVkX1+QvcHdOT0d6fddgxORm0iyaEaizyEy4rw="},{"num_cand":"U2FsdGVkX198VgADEfk9mynnqMJufK6C+f2NOwGC5sM=","cpf":"U2FsdGVkX181ltI/oQWmt8Tt9M/TWtOUgNB63ozBG1A="},{"num_cand":"U2FsdGVkX1/1zipT8s0nol2PeJv4mUwMg6cnufPFiOA=","cpf":"U2FsdGVkX1+G98kfVPrMbH+3aN1CUlWqxFLV04VKf7A="},{"num_cand":"U2FsdGVkX18Z6nkOW2V0rtpoWSxY2iUWlgKrj4bhBcc=","cpf":"U2FsdGVkX19OV3n1dbGZ44lipiPGilyFjcpYsEFp6kg="},{"num_cand":"U2FsdGVkX1+Ir7xijr3W4lpxQpt4+2gh0PLmV89eR+g=","cpf":"U2FsdGVkX1/0E3WCGUY3ikm16KuZqaIe4vg8ZcKFm08="},{"num_cand":"U2FsdGVkX1+xAD7MhA90tkDNur6OnfW/1PkHakBOb7w=","cpf":"U2FsdGVkX1/O70UlYviv7QQuw7fzTap2i6/ywZqT5OI="},{"num_cand":"U2FsdGVkX1+A2mDyavPlkAwJPtkvu+1oxc6biI/W5uo=","cpf":"U2FsdGVkX1+mtExeWxJA6ruH5/81XEFniKMR3kyOGCQ="},{"num_cand":"U2FsdGVkX19NWflDXFYbSULmsmZ1SFByNuzYD1ubG+Q=","cpf":"U2FsdGVkX19zp0uCNEd2WZMpoDxgEEue7ql6ZWZ52F4="},{"num_cand":"U2FsdGVkX1+hf702wX/wqKDeamWKqQtNMQQ5FaiB8SM=","cpf":"U2FsdGVkX1+wGzjMa4A/Ts1mN30At/OE3LqjMCcMnFk="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2208/2208_re_isen/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
